<template>
    <div class="app-main plan-info-page">
        <el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="14">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="10" class="app-main-header-btns">
				<el-button size="small" type="primary" v-show="checkRole('cgy_role') && orderInfo.deliverState == 1" :disabled="tableEditFlag" @click="handerOrder(3)">确认收货</el-button>
				<el-button size="small" type="primary" v-show="checkRole('gys_role') && orderInfo.deliverState == 0" :disabled="editHeaderFlag || tableEditFlag" @click="handerOrder(2)">发布送货单</el-button>
				<el-button size="small" type="primary" v-show="checkRole('gys_role') && orderInfo.deliverState == 0" @click="handerOrder(1)">{{editHeaderFlag?'保存':'编辑'}}</el-button>
				<el-button size="small" type="primary" v-show="checkRole('gys_role') && editHeaderFlag" @click="handerOrder(4)">取消</el-button>
				<el-button size="small" type="primary" @click="$router.back(-1)" :disabled="editHeaderFlag || tableEditFlag">返回 </el-button>
			</el-col>
		</el-row>
        <div class="order-info-main">
            <div class="info-wrap">
                <el-row class="mg-b5">
                    <el-col :span="24">
                        <el-card class="box-card mg-b5" v-if="orderInfo">
							<el-descriptions :column="4" :border="true" :colon="false" size="mini">
								<el-descriptions-item labelClassName="my-descriptions-label" label="送货单号"> {{orderInfo.deliverOrderCode}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="制单日期"> {{orderInfo.createOrderTime}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="客户"> {{orderInfo.customName}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="采购员"> {{orderInfo.cgyName}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="送货单状态">{{getStateText(orderInfo)}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="送货联系人">
                                    <span v-if="!editHeaderFlag">{{orderInfo.lxrName}}</span>
                                    <el-input v-if="editHeaderFlag" class="input-head-bar" size="mini" v-model="orderInfo.lxrName"/>
                                </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="送货车牌号">
                                    <span v-if="!editHeaderFlag">{{orderInfo.carLicense}}</span>
                                    <el-input v-if="editHeaderFlag" class="input-head-bar" size="mini" v-model="orderInfo.carLicense"/>
                                </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="司机电话">
                                    <span v-if="!editHeaderFlag">{{orderInfo.driverPhone}}</span>
                                    <el-input v-if="editHeaderFlag" class="input-head-bar" size="mini" v-model="orderInfo.driverPhone"/>
                                </el-descriptions-item>
							</el-descriptions>
						</el-card>
                    </el-col>
                    <el-col :span="24">
                        <el-card class="box-card" style="min-height:calc(100vh - 200px);position: relative;">
                            <el-tabs v-model="activeName">
								<el-tab-pane label="物料列表" name="first">
                                     <div class="materia-table-box order-materia-table-box" :key="tableEditFlag?'edit':'normal'">
                                         <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="'calc(100vh - 280px)'">
                                                <!-- <el-table-column prop="lineNumber" label="订单行号" :show-overflow-tooltip="true"></el-table-column> -->
                                                <el-table-column prop="code" label="物料编码" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="name" label="物料名称" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="sspace" label="规格" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="model" label="型号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="figueNumber" label="图号" :show-overflow-tooltip="true"></el-table-column>
                                                <!-- <el-table-column prop="a" label="确认收货" :show-overflow-tooltip="true"></el-table-column> -->
                                                <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="taxPrice" label="含税单价" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="taxAmount" label="含税金额" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="taxRate" label="税率" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="shuie" label="税额" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="xjOrderCode" label="询价单号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="a" label="合同号" :show-overflow-tooltip="true"></el-table-column>
                                                <!-- <el-table-column prop="remainUnDeliverNum" label="未送货数量"></el-table-column> -->
                                                <el-table-column prop="deliverNum" label="送货数量">
                                                    <template slot-scope="scope">
                                                        <span v-if="!tableEditFlag || (tableEditFlag && checkRole('cgy_role'))">{{scope.row.deliverNum}}</span>
                                                        <el-input v-if="tableEditFlag && checkRole('gys_role')" size="mini" v-model="scope.row.deliverNum" @keyup.native="tenderNumChange(scope.row,'deliverNum')" class="table-edit-input"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="confirmNum" v-if="checkRole('cgy_role') || orderInfo.deliverState == 2" label="收货数量">
                                                    <template slot-scope="scope">
                                                        <span v-if="!tableEditFlag">{{scope.row.confirmNum}}</span>
                                                        <el-input v-if="tableEditFlag" size="mini" v-model="scope.row.confirmNum" @keyup.native="tenderNumChange(scope.row,'confirmNum')" class="table-edit-input"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="remark" label="行备注" :show-overflow-tooltip="true">
                                                    <template slot-scope="scope">
                                                        <span v-if="!tableEditFlag || (tableEditFlag && checkRole('cgy_role'))">{{scope.row.remark}}</span>
                                                        <el-input v-if="tableEditFlag && checkRole('gys_role')" size="mini" type="textarea" :rows="1" v-model="scope.row.remark"  class="table-edit-input"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="操作"  v-if="checkRole('gys_role')">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" v-if="tableData.length<=1 || !tableEditFlag" :disabled="true" size="small">移除</el-button>
                                                        <el-button type="text" v-if="tableData.length>1 && tableEditFlag" size="small" @click="removeRow(scope.row,'info')">移除</el-button>
                                                    </template>
                                                </el-table-column>
                                         </el-table>
                                     </div>
								</el-tab-pane>
							</el-tabs>
                            <div class="tab-pane-btns">
								<el-button v-if="activeName == 'first' && orderInfo && orderInfo.deliverState == 1 && checkRole('cgy_role') && !tableEditFlag" size="small" type="primary" @click="updateOrder">编辑</el-button>
								<el-button v-if="activeName == 'first' && orderInfo && orderInfo.deliverState == 0 && checkRole('gys_role') && !tableEditFlag" size="small" type="primary" @click="updateOrder">编辑</el-button>
								<el-button v-if="activeName == 'first' && orderInfo && orderInfo.deliverState == 0 && checkRole('gys_role') && tableEditFlag" size="small" type="primary" @click="canelUpdateOrder">取消</el-button>
								<el-button v-if="activeName == 'first' && tableEditFlag" size="small" type="primary" @click="saveUpdateOrder">保存</el-button>
							</div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import { getShById,getShMxList,saveTopEdit,updateList,publicDeliverOrder,confirmDeliverOrder } from '@/api/transport/index.js'
    export default {
        components: {

        },
        data() {
            return {
                hId:'',
                editHeaderFlag:false,
                tableEditFlag:false,
                activeName:'',
                oldOrderInfo:{},
                orderInfo:{},
                oldTableData:[],
                tableData:[],
                loading:'',
            };
        },
        created() {
            let route = this.$route;
            this.hId = route.params.id;  // 详情id
            this.getInfoById()
            this.getTableList()
        },
        mounted() {
            this.activeName = 'first'
        },
        methods: {
            getInfoById(){
                getShById({id:this.hId}).then(({data:res})=>{
                    this.orderInfo = res.data || {};
                    this.oldOrderInfo = {...this.orderInfo};
                })
            },
            getTableList(){
                getShMxList({
                    page: 1, //当前页码
                    limit: 2000, //当前每页显示的数量
                    objMap: {
                        deliverOrderId: this.hId,
                    }
                }).then(({data:res})=>{
                    console.log(res)
                    this.tableData = res.data||[];
                    this.tableData.forEach((item)=>{
                        item['code'] = item.commodity['code'];
                        item['name'] = item.commodity['name'];
                        item['sspace'] = item.commodity['sspace'];
                        item['model'] = item.commodity['model'];
                        item['unit'] = item.commodity['unit'];
                        item['figueNumber'] = item.commodity['figueNumber'];
                    })
                    this.oldTableData = JSON.stringify(this.tableData);
                })
            },
            getStateText(row){
                let text = '';
                if(this.checkRole('gys_role')){ // 供应商
                    // deliverState:1,		 // 0 待发布， 1 送货中 2待签收,
                    if(row.deliverState == 0){
                        text = '待发布'
                    }
                    if(row.deliverState == 1){
                        text = '送货中'
                    }
                    if(row.deliverState == 2){
                        text = '待签收'
                    }
                }else{  // 采购员
                    if(row.deliverState == 1){
                        text = '未签收'
                    }
                    if(row.deliverState == 2){
                        text = '已签收'
                    }
                }
                return text
            },
            async handerOrder(type){
                if(type == 1){
                    if(this.editHeaderFlag){    // 保 存
                        let param = {
                            id:this.orderInfo.id,
                            lxrName:this.orderInfo.lxrName,
                            carLicense:this.orderInfo.carLicense,
                            driverPhone:this.orderInfo.driverPhone
                        }
                        const { data: res } = await saveTopEdit(param)
                        if(res.code == 0){
                            this.$success('保存成功');
                            this.getInfoById()
                        }
                        this.editHeaderFlag = false;
                    }else{  // 编辑
                        this.editHeaderFlag = true;
                    }
                }
                if(type == 2){  // 发布送货单
                    this.publicDeliverOrderFun();
                }
                if(type == 3){  // 确认收货
                    this.confirmDeliverOrderFun()
                }
                if(type == 4){  // 顶部取消编辑
                    this.orderInfo = {...this.oldOrderInfo}
                    this.editHeaderFlag = false;
                }
            },
            removeRow(row){
                let newTable = [];
                this.tableData.forEach((item)=>{
                    if(row.id != item.id){
                        newTable.push(item)
                    }
                })
                this.tableData = newTable;
            },
            canelUpdateOrder(){
                this.tableData = JSON.parse(this.oldTableData);
                this.tableEditFlag = false;
            },
            updateOrder(){
                this.tableEditFlag = true;
            },
            async saveUpdateOrder(){
                if(this.loading){return}
                let pramar = [];
                this.tableData.forEach((item)=>{
                    if(this.checkRole('gys_role')){
                        pramar.push({
                            id:item.id,
                            deliverNum:item.deliverNum||0,
                            remark:item.remark,
                        })
                    }else{
                        pramar.push({
                            id:item.id,
                            confirmNum:item.confirmNum||0,
                        })
                    }
                })
                this.loading = false;
                const { data: res } = await updateList(pramar)
                if(res.code == 0 ){
                    this.$success('保存成功');
                    this.getTableList();
                }
                this.loading = false;
                this.tableEditFlag = false;
            },
            async publicDeliverOrderFun(){
                if(this.loading){return}
                const { data: res } = await publicDeliverOrder({id:this.orderInfo.id});
                if(res.code == 0){
                    this.$success('发布成功');
                     this.getInfoById()
                    this.getTableList()
                }
            },
            async confirmDeliverOrderFun(){
                if(this.loading){return}
                const { data: res } = await confirmDeliverOrder({id:this.orderInfo.id});
                if(res.code == 0){
                    this.$success('确认成功');
                    this.getInfoById()
                    this.getTableList()
                }
            },

            // 整数
            tenderNumChange(row,prop){
                let curVal = row[prop];
                if(curVal){
                    curVal = curVal.replace(/[^\.\d]/g, '')
                    curVal = curVal.replace('.', '')
                }
                // if( prop == 'deliverNum' && row.remainUnDeliverNum && curVal>row.remainUnDeliverNum){
                //     curVal = row.remainUnDeliverNum
                // }
                if(curVal<0){
                    curVal = 0
                }
                row[prop] = curVal;
            },
        },
        watch: {
            'activeName':function(nVal){

            }
        },
    };
</script>

<style scoped="scoped" lang="scss">
    .order-info-main{
		width: 100%;
		display: flex;
		.info-wrap{
			width: 100%;
		}
	}
	.tab-pane-btns{
		height: 32px;
		position: absolute;
		right: 10px;
    	top: 5px;
		text-align: right;
		.show-tender-row-switch{
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			display: flex;
			.el-switch{
				margin-top: 6px;
			}
			span{
				line-height: 32px;
				margin-right: 10px;
			}
		}
	}
</style>
<style lang="scss">
.plan-info-page{
    .input-head-bar{
    }
}
.order-materia-table-box{
    .el-table--mini .el-table__cell{
        padding: 2px 0;
    }
    .el-table {
        .cell{
            padding-left: 5px;
            padding-right: 5px;
            .table-edit-input{
                .el-input-group__append{
                    padding: 0 5px;
                }
            }

        }
    }
}
</style>
